/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerHatchery } from '../../models/customer-hatchery';

export interface DeleteCustomerHatchery$Params {
  customerHatcheryId: number;
}

export function deleteCustomerHatchery(http: HttpClient, rootUrl: string, params: DeleteCustomerHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerHatchery>> {
  const rb = new RequestBuilder(rootUrl, deleteCustomerHatchery.PATH, 'delete');
  if (params) {
    rb.path('customerHatcheryId', params.customerHatcheryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerHatchery>;
    })
  );
}

deleteCustomerHatchery.PATH = '/api/customer/hatchery/{customerHatcheryId}';
